import { getCall } from '../../utils/apiCalls'
import { DASHBOARD_DATA, SET_MERCHANT_ID, } from './actionTypes'
import { GET_DASHBOARD_DATA, DASHBOARD_DOWNLOAD_REPORT } from '../../config/urls'
import FileDownload from "js-file-download";


export const fetchData = (query) => dispatch => {
  getCall(GET_DASHBOARD_DATA, query, ['merchant'])
    .then(res => {
      if(!res.data || !res.data.body) {
        alert((res.data || {}).error || 'Error, please try later');
        return;
      }
      dispatch({
        type: DASHBOARD_DATA,
        payload: { data: res.data || [] },
      })
    })
}

export const setMerchantId = (merchantId) => dispatch => {
  dispatch({
    type: SET_MERCHANT_ID,
    payload: merchantId,
  })
}

export const downloadReport = (query) => (dispatch) => {
  getCall(
    `${DASHBOARD_DOWNLOAD_REPORT}?from_date=${query.start_date}&to_date=${query.end_date}`,
    {},
    ['merchant']
  ).then((res) => {
    FileDownload(
      res.data,
      `${query.start_date} to ${query.end_date}.csv`
    );
  });
};